import {ControlledAutocompleteSelect} from '@hm/fundamental'
import React, {FC, useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {DifficultyFilter, DIFFICULTY_FILTER_OPTIONS} from '../../types'

interface DifficultyFilterDropdownProps {
  value: DifficultyFilter
  onChange: (value: DifficultyFilter) => void
}

export const DifficultyFilterDropdown: FC<DifficultyFilterDropdownProps> = ({value, onChange}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const options = useMemo(
    () =>
      DIFFICULTY_FILTER_OPTIONS.map((option) => ({
        label: t(`comparativeAnalysis.chart.difficultyFilter.${option}`),
        value: option
      })),
    [t]
  )

  const selectedValues = useMemo(() => [value], [value])

  return (
    <div className="w-full max-w-[300px] [&_[data-cy='difficulty-filter-dropdown-clear']]:hidden">
      <ControlledAutocompleteSelect
        label={t('comparativeAnalysis.chart.difficultyFilter.label')}
        options={options}
        selectedValues={selectedValues}
        onChange={(values) => {
          const selected = values[values.length - 1] as DifficultyFilter | undefined
          if (selected) onChange(selected)
        }}
        data-cy="difficulty-filter-dropdown"
      />
    </div>
  )
}
